module.exports = __webpack_public_path__ + "static/media/time.961ddaf6.svg";